import { render, staticRenderFns } from "./DatosDespachoInst.vue?vue&type=template&id=36d738e4"
import script from "./DatosDespachoInst.vue?vue&type=script&lang=js"
export * from "./DatosDespachoInst.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports